<template>
  <btn-nav>
    <template v-if="!preview">
      <button
        @click="goTo('/event/' + $route.params.id + '/content')"
        class="btn text_btn edit-btn"
      >Edit event</button>
      <button @click="goTo('/event/' + $route.params.id + '/preview')" class="btn text_btn">
        <img src="@/assets/img/eye.svg" />Preview
      </button>
      <button @click="$emit('save')" class="btn">Save</button>
      <button @click="publishEvent()" class="btn dark_btn">Publish</button>
    </template>

    <template v-else>
      <button
        @click="goTo('/event/' + $route.params.id + '/management')"
        class="btn text_btn edit-btn"
      >Exit Preview</button>

      <div class="btn text_btn edit-btn" :style="{maxWidth: '330px', minWidth: '300px'}">
        <label :style="{whiteSpace: 'pre', marginRight: '30px'}">Select Template</label>
        <div>
          <v-select
            id="mySelect-1"
            :clearable="false"
            @input="$emit('selectedTemplate', $event)"
            :options="templates"
            :reduce="t => t.id"
            :value="event.template_id"
            label="name"
          ></v-select>
        </div>
      </div>
      <button @click="$parent.openNewTab()" class="btn">View Event</button>
    </template>
  </btn-nav>
</template>

<script>
import BtnNav from "@/components/BtnNav.vue";
const fb = require("../firebaseConfig");
const db = fb.default.db;
var moment = require("moment");

export default {
  name: "ManagementBar",
  props: ["preview", "event"],
  components: {
    "btn-nav": BtnNav
  },
  data() {
    return {
      templates: [
        {
          name: "Template1",
          id: "1"
        },
        {
          name: "Template2",
          id: "2"
        },
        {
          name: "Template3",
          id: "3"
        },
        {
          name: "Template4",
          id: "4"
        },
        {
          name: "Template5",
          id: "5"
        }
      ]
    };
  }
};
</script>

<style lang="scss">
.edit-btn {
  margin-right: auto !important;
}
#mySelect-1 {
  width: 100%;
  .vs__search {
    width: 100%;
    padding: 7px 0;
    text-indent: 15px;
  }
  .vs__actions {
    padding: 1px 6px 0 3px;
  }
}
</style>

